const PAGE_TYPES = {
    HOME: "rto_home",
    STATE: "rto_state",
    RTO: "rto"
};

export const computeBreadcrumbList = ({ pageType, state, stateUrl, rto }) => {
    const computedList = [
        {
            name: "Home",
            url: `/`
        },
        {
            name: "Vehicle Registration Details",
            ...(pageType !== PAGE_TYPES.HOME && { url: "/rto-vehicle-registration-details/" })
        }
    ];

    const statePageRedirection = {
        name: state,
        ...(pageType === PAGE_TYPES.RTO && { url: `/rto-vehicle-registration-details-${stateUrl}/` })
    };

    if (pageType === PAGE_TYPES.STATE) {
        computedList.push(statePageRedirection);
    }

    if (pageType === PAGE_TYPES.RTO) {
        computedList.push(statePageRedirection, { name: (rto || "").toUpperCase() });
    }

    return computedList;
};
